export const setActivateAccountInfo = (info) => ({
    type: 'SET_ACTIVATE_ACCOUNT_INFO',
    info
})

export const setClearActivateAccountInfo = () => ({
    type: 'SET_CLEAR_ACTIVATE_ACCOUNT_INFO',
});